import { Typography } from "@material-tailwind/react";
 
function Footer() {
  return (
    <footer className="flex flex-row flex-wrap items-center justify-center gap-y-6 gap-x-12 border-t border-blue-gray-50 w-full py-4 mt-5 px-6 text-center md:justify-between">
	<Typography color="blue-gray" className="font-normal">
        &copy; 2025 La tournée d&apos;accord
    </Typography>
	<ul className="flex flex-wrap items-center gap-y-2 gap-x-8">
		<li>
			<Typography as="a" href="/MentionsLegales" color="blue-gray" className="font-normal transition-colors hover:text-blue-500 focus:text-blue-500">Mentions légales</Typography>
		</li>
	</ul>
</footer>
  );
}
export default Footer;